import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "theme-toggle",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.themeStore.toggleTheme && _ctx.themeStore.toggleTheme(...args)), ["stop"]))
  }, [
    _createElementVNode("img", {
      src: _ctx.themeStore.isDarkMode ? _ctx.ASSETS.LIGHTBULB_REGULAR : _ctx.ASSETS.LIGHTBULB_SOLID,
      class: "lamp-icon"
    }, null, 8, _hoisted_1)
  ]))
}